module.exports = __webpack_public_path__ + "static/media/my-goal-bg.7ae23802.svg";